import store from '../store'
export function getToken() {
    return localStorage.getItem('access_token');
}
export function getUserId() {
    if(getToken()){
        return JSON.parse(localStorage.getItem('user')).userId;
    }
}
export function getYXToken() {
    return JSON.parse(localStorage.getItem('user')).yxToken;
}
export function getShopId() {
    return JSON.parse(localStorage.getItem('user')).shopId;
}